<template>
    <div>

        <h3 class="text-center text-45 font-ww-bold leading-none">
            Choose Your Perfect Bundle
        </h3>

        <div data-option-section="" class="px-3 py-7 mx-auto max-w-6xl sm:px-5 lg:px-16 md:pt-10 md:pb-9"
            id="the-products-test">

            <div v-if="Object.keys(state.items).length > 1"
                class="flex w-full text-2xl text-white rounded-lg bg-brownCoffee lg:text-26 xl:text-32">
                <div
                    class="relative us-max:text-xl md:px-6 px-4 py-4 font-bold tracking-widest uppercase bg-white bg-opacity-20 font-ww-bold text-25 md-max:text-center">
                    Step 1
                </div>
                <div class="md:px-8 px-4 py-4 text-2xl us-max:text-xl font-ww-regular md-max:text-center">
                    Choose a Coffee
                </div>
            </div>
            <!-- STEP 1 -->
            <div class="grid grid-cols-12 gap-x-6 gap-y-6 justify-center mt-6 mb-8 text-center lg:mt-10 sm:gap-y-4"
                v-if="Object.keys(state.items).length > 1">
                <div class="relative col-span-12 w-full sm-max:mb-0 lg:col-span-6" v-for="(item, index) in state.items"
                    :key="index">



                    <!-- Selection Circle Indicator (Top-Left) -->


                    <label :data-event-label="item.Name" data-event-action="step_1_choice"
                        data-event-name="experiment_event" :data-testid="'step1-choice-' + index"
                        class="flex overflow-hidden relative flex-col items-center h-full rounded-lg border-2 transition-all duration-300 cursor-pointer"
                        :class="state.active.items == index ? 'border-[#87BC4A] ring-2 ring-[#87BC4A] shadow-[0_10px_30px_rgba(135,188,74,0.25)] z-[2] bg-[#F3F9EE]' : 'border-gray-200 hover:border-gray-300'">

                        <div class="flex gap-x-3 items-center px-3 py-5 w-full sm:px-5 md:gap-x-6 md:py-5"
                            :class="state.active.items == index ? 'bg-[#33591F]' : 'bg-[#CBCBCB]'">
                            <div class="flex left-3 z-20 justify-center items-center w-10 h-10 rounded-full transition-all duration-300 pointer-events-none md:w-10 md:h-10"
                                :class="state.active.items == index ? 'bg-[#7BBD41] border-white shadow-sm' : 'bg-white border-gray-300'">
                                <svg v-if="state.active.items == index" xmlns="http://www.w3.org/2000/svg"
                                    class="text-white md-max:w-6" width="18" height="13" viewBox="0 0 18 13"
                                    fill="none">
                                    <path
                                        d="M5.71667 12.6583L0.175 7.11667C-0.0583333 6.88334 -0.0583333 6.475 0.175 6.18333L1.05 5.30833C1.28333 5.075 1.69167 5.075 1.98333 5.30833L6.18333 9.50833L15.5167 0.175C15.75 -0.0583333 16.1583 -0.0583333 16.45 0.175L17.325 1.05C17.5583 1.28333 17.5583 1.69167 17.325 1.98333L6.65 12.6583C6.35833 12.8917 5.95 12.8917 5.71667 12.6583Z"
                                        fill="white" />
                                </svg>
                            </div>


                            <h3 class="tracking-tight leading-tight text-white text-2xl xl:text-3xl font-ww-medium">
                                {{
                                    item.Name }}</h3>

                        </div>

                        <!-- Selected Background Overlay (Subtle) -->
                        <div v-if="state.active.items == index" class="absolute inset-0 pointer-events-none"></div>

                        <div
                            class="flex relative md:items-center items-start p-6 h-full flex-row md-max:px-3 md-max:gap-x-4">


                            <div class="absolute top-0 right-0"
                                v-if="item.SubName == 'BEST SELLER' || item.SubName == 'DR PICK'">
                                <div class="relative flex items-center h-[28px]">
                                    <svg class="absolute inset-0 w-full h-full" viewBox="0 0 131 28" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                                        <path d="M0 0L131 0V28H15.1274C10.5932 28 6.62642 24.9493 5.4625 20.567L0 0Z"
                                            fill="#F1594B" />
                                    </svg>
                                    <div
                                        class="relative z-10 pt-0.5 pr-4 pl-6 -mt-1 text-sm tracking-wide leading-none text-white uppercase whitespace-nowrap font-ww-bold">
                                        {{ item.SubName == 'DR PICK' ? "DR. CHARLES PICK" : item.SubName }}
                                    </div>
                                </div>
                            </div>


                            <input type="radio" :name="'test8-step4' + uniqueId" class="hidden"
                                :id="'test8-' + index + uniqueId + 'roastnew'" :checked="state.active.items == index"
                                @click="setProduct(index)" :value="index" />

                            <!-- Product Image Column -->
                            <div class="flex-shrink-0 w-36 md:w-4/12">
                                <nuxt-img class="object-contain mx-auto w-full h-auto max-h-[210px]" width="196"
                                    height="285" loading="lazy" format="webp" sizes="sm:150px md:180px" alt=""
                                    :src="item.Image.url" />
                            </div>

                            <!-- Product Info Column -->
                            <div class="flex flex-col gap-1.5 mt-3 w-full text-left md:pl-4 md:w-8/12">
                                <!-- Name -->




                                <!-- Features List -->
                                <div
                                    class="flex flex-wrap md-max:justify-start gap-y-1.5 gap-x-2.5 items-center py-0.5 uppercase text-15 font-ww-regular md:justify-start justify-center">
                                    <div class="flex gap-x-1 items-center md:w-full sm:text-base text-sm">
                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="11.0603" cy="11.0603" r="10.5603" fill="white"
                                                stroke="#33591F" />
                                            <path
                                                d="M12.3169 7.85546C12.3138 7.85234 12.3107 7.84923 12.3076 7.84923C11.404 7.1949 11.2077 5.67125 11.2046 5.64944C11.189 5.51235 11.0643 5.41576 10.9272 5.43134C10.7902 5.44691 10.6936 5.57155 10.7091 5.70865C10.7185 5.77719 10.921 7.39743 11.9461 8.20132C11.915 8.31349 11.7966 8.5316 11.7529 8.60949C11.7187 8.67181 11.6906 8.72166 11.6719 8.76217C11.6688 8.7684 11.6657 8.77463 11.6657 8.77775C11.6158 8.91796 11.5691 9.05817 11.5224 9.19527C11.3572 9.69069 11.2014 10.155 10.9179 10.5694C10.5502 11.0897 10.1234 11.5477 9.7775 11.7908C9.54693 11.9497 9.29143 12.065 9.02347 12.1834C8.77732 12.2955 8.5187 12.4077 8.27567 12.5635C8.1448 12.6476 8.02017 12.7411 7.90177 12.8408C7.66496 13.034 7.44062 13.2147 7.16331 13.2427C7.11657 13.2459 7.07295 13.2521 7.02933 13.2552C6.74579 13.2801 6.44978 13.3051 6.13508 13.4889C5.03208 14.1401 5.057 15.6388 5.06947 16.3586C5.07258 16.4957 5.18164 16.6047 5.31873 16.6047H5.32185C5.45895 16.6016 5.568 16.4895 5.568 16.3524V16.3492C5.54619 15.3428 5.63343 14.3551 6.38124 13.9158C6.59623 13.7911 6.80499 13.7724 7.06672 13.7506C7.11346 13.7475 7.1602 13.7413 7.20693 13.7382C7.63069 13.6977 7.93604 13.4484 8.21023 13.2303C8.31306 13.143 8.42211 13.062 8.5374 12.9872C8.75239 12.8502 8.97985 12.7473 9.22288 12.6414C9.50019 12.5168 9.78997 12.389 10.0579 12.2021C10.625 11.8032 11.1298 11.1302 11.323 10.856C11.647 10.3824 11.8246 9.85895 11.9929 9.35418C12.0365 9.22331 12.0832 9.08933 12.13 8.95535C12.1424 8.93354 12.1642 8.88992 12.1892 8.84941C12.3668 8.52848 12.6098 8.08915 12.3169 7.85546Z"
                                                fill="#105857" />
                                            <path
                                                d="M16.5653 8.66579C16.0512 7.71235 15.2286 7.13591 14.1879 6.99882C14.1848 6.99882 14.1817 6.99882 14.1754 6.99882C14.1131 6.99259 14.0539 6.99259 13.9978 6.99259C13.8825 6.98947 13.7766 6.98947 13.7143 6.95208C13.7112 6.95208 13.7112 6.94896 13.7081 6.94896C13.5086 6.83679 12.7235 5.93632 12.6798 5.29757C12.6705 5.16047 12.5521 5.05765 12.415 5.067C12.2779 5.07634 12.1751 5.19475 12.1844 5.33184C12.2374 6.16066 13.1161 7.18577 13.4619 7.38518C13.6364 7.488 13.8233 7.49112 13.9916 7.49424C14.0415 7.49424 14.0882 7.49424 14.1318 7.50047C15.0167 7.61575 15.6866 8.09248 16.126 8.91194C16.4905 9.59743 16.6743 10.4917 16.6401 11.4358C16.5435 13.8163 15.3657 15.5425 13.3217 16.2996C12.7422 16.5177 10.7262 16.957 9.10285 16.1158C9.10285 16.1158 9.09973 16.1158 9.09973 16.1127C8.80061 15.9631 8.52642 15.7138 8.2273 15.3243L8.22418 15.3181C7.99049 15.0034 7.67268 14.5703 7.0464 14.8165C6.35156 15.0782 6.35156 16.0846 6.35156 16.5115C6.35156 16.6486 6.46373 16.7607 6.60083 16.7607C6.73793 16.7607 6.8501 16.6486 6.8501 16.5115C6.8501 16.2124 6.8501 15.4241 7.224 15.2807H7.22711C7.47327 15.1841 7.56674 15.262 7.82536 15.611L7.83159 15.6172L7.8347 15.6203C8.17745 16.0721 8.51084 16.3682 8.87851 16.552C9.58269 16.9165 10.4053 17.1004 11.3213 17.1004C11.4491 17.1004 11.5768 17.0973 11.7077 17.091C12.549 17.0443 13.2313 16.8605 13.4962 16.7576C14.6241 16.3401 15.5121 15.6546 16.1415 14.7168C16.7491 13.81 17.0856 12.707 17.1355 11.4451C17.1729 10.4138 16.9703 9.42917 16.5653 8.66579Z"
                                                fill="#105857" />
                                            <path
                                                d="M15.8179 11.0426C15.7774 10.9492 15.6372 10.6781 15.3661 10.6407C15.363 10.6407 15.3599 10.6407 15.3567 10.6407C15.2228 10.6282 14.9641 10.6625 14.7429 11.052C14.2226 11.8528 13.4187 12.2859 12.8329 12.5102C11.9044 12.8716 10.9634 12.934 9.96633 12.9963C9.71084 13.0119 9.41172 13.043 9.12506 13.1583C8.67326 13.3297 8.35544 13.6724 8.25574 14.0993C8.15603 14.5262 8.28378 14.9748 8.61094 15.3332C8.83217 15.57 9.14687 15.76 9.57062 15.9158C10.0847 16.1028 10.63 16.1994 11.1784 16.1962C11.5772 16.1962 11.9761 16.1464 12.3655 16.0529C13.2442 15.841 14.0886 15.3705 14.8052 14.6913C15.3474 14.1678 15.7026 13.6319 15.8927 13.0492C16.1357 12.3731 16.1077 11.644 15.8179 11.0426ZM15.4191 12.8841C15.4191 12.8872 15.4159 12.8903 15.4159 12.8903C15.2508 13.3951 14.9392 13.8656 14.4563 14.3299C13.8051 14.9499 13.0386 15.3768 12.244 15.57C11.3872 15.7756 10.521 15.7351 9.73888 15.4484C9.39614 15.3207 9.13752 15.168 8.9755 14.9935C8.76362 14.763 8.67638 14.4794 8.73869 14.2146C8.80101 13.9497 9.00666 13.7347 9.30266 13.6226C9.30578 13.6226 9.30578 13.6226 9.30889 13.6194C9.53323 13.5291 9.7825 13.5042 9.99749 13.4917C10.9852 13.4294 12.0103 13.3639 13.0074 12.9745C14.1945 12.5227 14.8333 11.8247 15.1604 11.3168C15.1636 11.3137 15.1667 11.3075 15.1698 11.3013C15.1978 11.2421 15.2415 11.1891 15.2913 11.1455C15.3193 11.1766 15.3412 11.2109 15.3567 11.2483C15.3567 11.2514 15.3599 11.2545 15.363 11.2576C15.5967 11.7406 15.6185 12.3326 15.4191 12.8841Z"
                                                fill="#105857" />
                                        </svg>
                                        <span>STOMACH FRIENDLY</span>
                                    </div>





                                    <div class="flex gap-x-1 items-center">
                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="11.0603" cy="11.0603" r="10.5603" fill="white"
                                                stroke="#33591F" />
                                            <path
                                                d="M9.83192 7.03274C8.67838 5.87979 6.42104 5.74609 4.82323 5.74609C4.65775 5.74609 4.52344 5.88038 4.52344 6.04585C4.52344 7.64367 4.65654 9.90101 5.81008 11.0546C6.29693 11.5414 7.04338 11.7591 7.78323 11.7591C8.58724 11.7591 9.38405 11.5019 9.83192 11.054C10.6911 10.1948 10.8488 8.04899 9.83192 7.03274ZM9.40805 10.6307C8.76652 11.2716 6.98524 11.3813 6.2346 10.6307C5.30347 9.69959 5.14218 7.80797 5.12479 6.34744C6.58531 6.36484 8.47693 6.5261 9.40803 7.45723C10.1587 8.20786 10.049 9.98976 9.40805 10.6307Z"
                                                fill="#105857" />
                                            <path
                                                d="M17.4283 6.93359C15.8305 6.93359 13.5732 7.0667 12.4196 8.22024C11.4027 9.23649 11.5604 11.3823 12.4196 12.2415C12.8675 12.6888 13.6637 12.946 14.4677 12.946C15.2075 12.946 15.9534 12.7289 16.4414 12.2421C17.5944 11.0886 17.7281 8.83123 17.7281 7.23338C17.7281 7.0679 17.5938 6.93359 17.4283 6.93359ZM16.0164 11.8176C15.2657 12.5682 13.4838 12.4585 12.8429 11.8176C12.202 11.1767 12.0923 9.39477 12.8429 8.64414C13.774 7.71301 15.6656 7.55175 17.1261 7.53435C17.1088 8.99547 16.9475 10.8871 16.0164 11.8176Z"
                                                fill="#105857" />
                                            <path
                                                d="M15.2592 9.52863C15.1885 9.37813 14.9858 9.32659 14.8365 9.39612C12.5372 10.4771 11.4076 12.3621 10.8944 14.2999C10.2595 10.1797 8.42301 8.92365 7.64418 8.39065C7.54706 8.3241 7.47151 8.27554 7.42955 8.23417C7.31264 8.11726 7.12257 8.11726 7.00565 8.23417C6.88874 8.35108 6.88874 8.54115 7.00565 8.65807C7.06501 8.71683 7.16754 8.79058 7.30603 8.88529C8.18379 9.48546 10.5155 11.0809 10.5155 17.4392C10.5155 17.6047 10.6498 17.739 10.8153 17.739C10.9807 17.739 11.115 17.6047 11.115 17.4398C11.115 14.8707 11.8051 11.4838 15.0919 9.93934C15.0919 9.93875 15.1405 9.91596 15.1405 9.91596C15.2898 9.84519 15.3299 9.67851 15.2592 9.52863Z"
                                                fill="#105857" />
                                        </svg>

                                        <span>ORGANIC</span>
                                    </div>

                                    <div class="flex gap-x-1 items-center">
                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <circle cx="11.0603" cy="11.0603" r="10.5603" fill="white"
                                                stroke="#33591F" />
                                            <path
                                                d="M15.8958 15.201C15.8142 15.0372 13.0551 9.49925 12.907 9.20195V6.08746H13.3005C13.4816 6.08746 13.6284 5.94064 13.6284 5.75955C13.6284 5.57846 13.4816 5.43164 13.3005 5.43164C12.4192 5.43164 10.0675 5.43164 9.05957 5.43164C8.87848 5.43164 8.73166 5.57846 8.73166 5.75955C8.73166 5.94064 8.87848 6.08746 9.05957 6.08746H9.45306V9.20193C5.00951 18.1211 7.16868 13.7872 6.46455 15.2006C6.13716 15.8554 6.61392 16.6242 7.34441 16.6242H15.0157C15.7485 16.6242 16.2218 15.8531 15.8958 15.201ZM10.0745 9.42532C10.0971 9.37989 10.1089 9.32983 10.1089 9.2791V6.08746H12.2512V9.2791C12.2512 9.32983 12.263 9.37989 12.2856 9.42532L13.3563 11.5745H12.1535C12.0163 11.1683 11.6319 10.8749 11.18 10.8749C10.7282 10.8749 10.3438 11.1683 10.2066 11.5745H9.00378L10.0745 9.42532ZM11.5517 11.9024C11.5517 12.1073 11.385 12.274 11.18 12.274C10.9751 12.274 10.8084 12.1073 10.8084 11.9024C10.8084 11.6974 10.9751 11.5307 11.18 11.5307C11.385 11.5307 11.5517 11.6974 11.5517 11.9024ZM15.0157 15.9684H7.34441C7.10062 15.9684 6.94205 15.712 7.05133 15.4934L8.67705 12.2303H10.2066C10.3438 12.6364 10.7282 12.9298 11.18 12.9298C11.6319 12.9298 12.0163 12.6364 12.1535 12.2303H13.683L15.309 15.4939C15.418 15.712 15.2593 15.9684 15.0157 15.9684Z"
                                                fill="#105857" />
                                            <path
                                                d="M9.77745 13.1504C9.21091 13.1504 8.75 13.6113 8.75 14.1778C8.75 14.7444 9.21091 15.2053 9.77745 15.2053C10.344 15.2053 10.8049 14.7444 10.8049 14.1778C10.8049 13.6113 10.344 13.1504 9.77745 13.1504ZM9.77745 14.5495C9.57252 14.5495 9.40582 14.3828 9.40582 14.1778C9.40582 13.9729 9.57252 13.8062 9.77745 13.8062C9.98237 13.8062 10.1491 13.9729 10.1491 14.1778C10.1491 14.3828 9.98237 14.5495 9.77745 14.5495Z"
                                                fill="#105857" />
                                            <path
                                                d="M12.5477 13.4142C12.5067 13.2176 12.3105 13.1099 12.131 13.1646C11.9501 13.2223 11.8622 13.4051 11.9124 13.5736C11.9736 13.7611 12.1584 13.8404 12.3214 13.792C12.4942 13.7355 12.5775 13.5735 12.5477 13.4142Z"
                                                fill="#105857" />
                                            <path
                                                d="M13.5984 14.1133C13.5579 13.9191 13.3654 13.8088 13.1816 13.8637C12.9938 13.9248 12.9147 14.1101 12.9632 14.2727C13.0235 14.4579 13.2068 14.5402 13.3722 14.491C13.5481 14.4335 13.6278 14.2703 13.5984 14.1133Z"
                                                fill="#105857" />
                                            <path
                                                d="M12.2 14.8127C12.159 14.6164 11.9631 14.5082 11.7833 14.563C11.6002 14.6214 11.5151 14.8059 11.5647 14.972C11.6259 15.1597 11.8107 15.2388 11.9737 15.1904C12.1465 15.1339 12.2298 14.9719 12.2 14.8127Z"
                                                fill="#105857" />
                                        </svg>


                                        <span>TOXIN TESTED</span>
                                    </div>




                                </div>

                                <!-- Description -->
                                <div class="mt-5 text-lg font-normal !leading-5 font-ww-regular xl:pr-3"
                                    v-html="item.ExtraData?.htmlContent"></div>
                            </div>
                        </div>

                        <!-- Selected Indicator Mobile (Removed absolute green bar from bottom as per new design) -->
                    </label>
                </div>
            </div>

            <div v-if="Object.keys(state.variants).length > 1">
                <!-- STEP 2 -->
                <div class="flex w-full text-2xl text-white rounded-lg bg-brownCoffee lg:text-26 xl:text-32">
                    <div
                        class="relative us-max:text-xl md:px-6 px-4 py-4 font-bold tracking-widest uppercase bg-white bg-opacity-20 font-ww-bold text-25 md-max:text-center">
                        {{ Object.keys(state.items).length > 1 ? "Step 2" : "Step 1" }}
                    </div>
                    <div class="md:px-8 px-4 py-4 text-2xl us-max:text-xl font-ww-regular md-max:text-center">
                        Ground or Beans?
                    </div>
                </div>

                <div class="grid grid-cols-12 gap-x-6 gap-y-6 justify-center mt-6 mb-8 text-center lg:mt-10 sm:gap-y-4"
                    role="radiogroup" aria-label="Ground or Beans?">
                    <div class="col-span-12 w-full lg:col-span-6" v-for="(item, index) in state.variants" :key="index">
                        <div :data-option="item.Name" :data-event-label="item.Name" data-event-action="step_2_choice"
                            :data-testid="'step2-choice-' + index" data-event-name="experiment_event"
                            class="flex overflow-hidden relative flex-col items-center h-full rounded-lg border-2 transition-all duration-300 cursor-pointer"
                            :class="state.active.variants == index ? 'border-[#87BC4A] ring-2 ring-[#87BC4A] shadow-[0_10px_30px_rgba(135,188,74,0.25)] z-[2] bg-[#F3F9EE]' : 'border-gray-200 hover:border-gray-300'"
                            role="radio" :aria-checked="state.active.variants == index"
                            :tabindex="state.active.variants == index ? 0 : -1" @click="setType(index)"
                            @keydown.enter.prevent="setType(index)" @keydown.space.prevent="setType(index)"
                            @keydown.right.prevent="moveVariantRadio(1)" @keydown.down.prevent="moveVariantRadio(1)"
                            @keydown.left.prevent="moveVariantRadio(-1)" @keydown.up.prevent="moveVariantRadio(-1)">

                            <div class="flex gap-x-3 items-center px-3 py-5 w-full sm:px-5 md:gap-x-6 md:py-5"
                                :class="state.active.variants == index ? 'bg-[#33591F]' : 'bg-[#BCBCBC]'">
                                <div class="flex left-3 z-20 justify-center items-center w-10 h-10 rounded-full transition-all duration-300 pointer-events-none md:w-10 md:h-10"
                                    :class="state.active.variants == index ? 'bg-[#7BBD41] border-white shadow-sm' : 'bg-white border-gray-300'">
                                    <svg v-if="state.active.variants == index" xmlns="http://www.w3.org/2000/svg"
                                        class="text-white md-max:w-6" width="18" height="13" viewBox="0 0 18 13"
                                        fill="none">
                                        <path
                                            d="M5.71667 12.6583L0.175 7.11667C-0.0583333 6.88334 -0.0583333 6.475 0.175 6.18333L1.05 5.30833C1.28333 5.075 1.69167 5.075 1.98333 5.30833L6.18333 9.50833L15.5167 0.175C15.75 -0.0583333 16.1583 -0.0583333 16.45 0.175L17.325 1.05C17.5583 1.28333 17.5583 1.69167 17.325 1.98333L6.65 12.6583C6.35833 12.8917 5.95 12.8917 5.71667 12.6583Z"
                                            fill="white" />
                                    </svg>
                                </div>
                                <h3 class="text-2xl tracking-tight leading-tight capitalize xl:text-3xl md:text-2xl"
                                    :class="state.active.variants == index ? 'text-white font-ww-medium' : 'text-white font-ww-medium'">
                                    {{
                                        item.Name }}</h3>
                            </div>

                            <div
                                class="flex relative flex-col items-center px-6 md:px-10 py-6 w-full h-full md:flex-col">
                                <input type="radio" :name="'test8-step5' + uniqueId" class="hidden"
                                    :id="'test8-' + item.Name + uniqueId" :checked="state.active.variants == index"
                                    @click="setType(index)" :value="index" />

                                <div class="flex flex-shrink-0 justify-center w-full">
                                    <nuxt-img :src="item.Image.url" class="object-contain mx-auto md:mx-left"
                                        :width="index == 0 ? '248' : '271'" height="138" loading="lazy" format="webp"
                                        sizes="sm:234px md:234px lg:234px xl:234px" alt="product" />
                                </div>

                                <div class="flex flex-col gap-1.5 mt-8 w-full text-left">
                                    <p class="mb-4 md:leading-5 leading-6 text-left text-lg" v-html="item.Text"></p>
                                    <p class="mt-4 mb-2 text-sm text-left"
                                        v-if="state.isSubscription && hasSellingPlans">
                                        <span class="font-bold sm:text-xl text-lg bg-[#AC6143] block p-4 text-white">Get
                                            A Box Of Our
                                            Curated
                                            Seasonal Favorites For $21.08 per bag! (Normally 27.95)</span>
                                    </p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <!-- STEP 3 -->
            <div v-if="Object.keys(FilteredPacks).length > 1"
                class="flex w-full text-2xl text-white rounded-lg bg-brownCoffee lg:text-26 xl:text-32">
                <div
                    class="relative us-max:text-xl md:px-6 px-4 py-4 font-bold tracking-widest uppercase bg-white bg-opacity-20 font-ww-bold text-25 md-max:text-center">
                    Step 3

                </div>
                <div class="md:px-8 px-4 py-4 text-2xl us-max:text-xl font-ww-regular md-max:text-center">
                    How many bags?
                </div>
            </div>


            <div class="grid grid-cols-12 gap-x-6 gap-y-6 justify-center mt-6 mb-8 text-center lg:mt-10 sm:gap-y-6"
                v-if="Object.keys(FilteredPacks).length > 1" role="radiogroup" aria-label="How many bags?">
                <div class="col-span-12 w-full"
                    :class="index === 0 && ThreeColums ? 'lg:col-span-12 mx-auto' : 'lg:col-span-6'"
                    v-for="(item, index) in FilteredPacks" :key="index">
                    <div data-index="0" :data-testid="'step3-choice-' + index" :data-event-label="item.Name"
                        data-event-action="step_3_choice" data-event-name="experiment_event"
                        class="flex overflow-hidden relative flex-col items-center h-full bg-white rounded-lg border-2 transition-all duration-300 cursor-pointer"
                        :class="state.active.packs == index ? 'border-[#87BC4A] ring-2 ring-[#87BC4A] shadow-[0_10px_30px_rgba(135,188,74,0.25)] z-[2] bg-[#F3F9EE]' : 'border-gray-200 hover:border-gray-300'"
                        role="radio" :aria-checked="state.active.packs == index"
                        :tabindex="state.active.packs == index ? 0 : -1" @click="setPack(index)"
                        @keydown.enter.prevent="setPack(index)" @keydown.space.prevent="setPack(index)"
                        @keydown.right.prevent="movePackRadio(1)" @keydown.down.prevent="movePackRadio(1)"
                        @keydown.left.prevent="movePackRadio(-1)" @keydown.up.prevent="movePackRadio(-1)">

                        <div class="flex gap-x-2 items-center px-3 py-3 w-full sm:px-5 md:gap-x-2"
                            :class="[state.active.packs == index ? 'bg-[#33591F]' : 'bg-[#BCBCBC]', index === 0 && ThreeColums ? 'md:py-2' : 'md:py-4']">
                            <div class="flex left-3 z-20 justify-center items-center h-8 rounded-full transition-all duration-300 pointer-events-none sm:w-8 min-w-10 min-h-10 md:w-10 md:h-10 md:min-w-10 md:min-h-10"
                                :class="[state.active.packs == index ? 'bg-[#7BBD41] border-white shadow-sm' : 'bg-white border-gray-300', index === 0 && ThreeColums ? 'md:w-8 md:h-8 md:min-w-8 md:min-h-8' : '']">
                                <svg v-if="state.active.packs == index" xmlns="http://www.w3.org/2000/svg"
                                    class="text-white md-max:w-6" width="18" height="13" viewBox="0 0 18 13"
                                    fill="none">
                                    <path
                                        d="M5.71667 12.6583L0.175 7.11667C-0.0583333 6.88334 -0.0583333 6.475 0.175 6.18333L1.05 5.30833C1.28333 5.075 1.69167 5.075 1.98333 5.30833L6.18333 9.50833L15.5167 0.175C15.75 -0.0583333 16.1583 -0.0583333 16.45 0.175L17.325 1.05C17.5583 1.28333 17.5583 1.69167 17.325 1.98333L6.65 12.6583C6.35833 12.8917 5.95 12.8917 5.71667 12.6583Z"
                                        fill="white" />
                                </svg>
                            </div>




                            <div class="flex justify-between items-center w-full sm-max:flex-row">
                                <h3 :class="index === 0 && ThreeColums ? '' : 'sm-max:flex-col'"
                                    class="tracking-tight leading-tight text-white capitalize font-ww-medium md-max:flex md-max:flex-col sm-max:!leading-none">
                                    <span class="text-3xl md:text-2xl sm-max:!leading-none"
                                        :class="index == 0 && ThreeColums ? 'xl:text-2xl' : 'xl:text-3xl'">{{ item.Price
                                        }}/</span><span class="text-2xl md:text-xl xl:text-2xl sm-max:!leading-none">{{
                                            item.PackSize.replace('x', '') }}
                                        {{ item.PackSize.replace('x', '') > 1 ? 'bags' : 'bag' }}</span>
                                </h3>

                                <div class="flex flex-col text-white custom-swatches-price" v-if="item.Discount"
                                    v-html="htmlTest(item.Discount) ? item.Discount : '<span>' + item.Discount + '</span>'">
                                </div>


                            </div>
                        </div>



                        <div :class="[(index === 0 && ThreeColums ? 'lg:flex-row lg:p-3 p-6 items-center' : 'md:flex-col py-6 lg:px-8 px-6'), (state.active.packs == index ? 'bg-[#F3F9EE] custom-active-bg' : '')]"
                            class="flex relative flex-col w-full h-full md-max:px-4">

                            <div v-if="index == (ThreeColums ? 2 : 1)" class="absolute top-0 right-0">
                                <div class="relative flex items-center h-[28px]">
                                    <svg class="absolute inset-0 w-full h-full" viewBox="0 0 131 28" fill="none"
                                        xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
                                        <path d="M0 0L131 0V28H15.1274C10.5932 28 6.62642 24.9493 5.4625 20.567L0 0Z"
                                            fill="#F1594B" />
                                    </svg>

                                    <div
                                        class="flex relative z-10 gap-x-2 items-center pt-0.5 pr-4 pl-4 -mt-1 text-sm tracking-wide leading-none text-white uppercase whitespace-nowrap font-ww-bold">
                                        <svg width="19" height="19" viewBox="0 0 19 19" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M2.10921 11.0319L1.4606 12.6807L3.08564 13.3875C3.20744 13.4405 3.28736 13.5598 3.28962 13.6927L3.32267 15.4651L5.09509 15.4982C5.22799 15.5006 5.34729 15.5803 5.40027 15.7021L6.10706 17.3274L7.75587 16.6788C7.87858 16.6306 8.01939 16.6575 8.11561 16.7501L9.39291 17.9792L10.67 16.7499C10.7655 16.6577 10.9063 16.6299 11.0297 16.6786L12.679 17.3272L13.3853 15.7021C13.4383 15.5803 13.5576 15.5004 13.6905 15.4982L15.4629 15.4651L15.496 13.6927C15.4987 13.56 15.5782 13.4407 15.7 13.3877L17.3252 12.6809L16.6766 11.0321C16.6279 10.9085 16.6558 10.7679 16.7477 10.6722L17.9772 9.39487L16.7477 8.11779C16.6558 8.02203 16.6279 7.88144 16.6766 7.75783L17.3252 6.10902L15.7 5.40222C15.5782 5.34925 15.4985 5.22994 15.496 5.09727L15.4629 3.32485L13.6907 3.2918C13.5578 3.28931 13.4388 3.20962 13.3856 3.08782L12.679 1.46255L11.0297 2.11117C10.9068 2.15984 10.7655 2.13177 10.67 2.03985L9.39291 0.810547L8.11584 2.03985C8.0203 2.13177 7.87994 2.16007 7.7561 2.11117L6.10729 1.46255L5.4005 3.08759C5.34752 3.20939 5.22821 3.28931 5.09532 3.29157L3.3229 3.32463L3.28985 5.09705C3.28736 5.22994 3.20767 5.34925 3.08587 5.40222L1.4606 6.10902L2.10921 7.75783C2.15766 7.88144 2.12982 8.02203 2.0379 8.11756L0.808594 9.39487L2.0379 10.6719C2.12982 10.7677 2.15789 10.9083 2.10921 11.0319ZM9.39291 2.44736C13.2239 2.44736 16.3404 5.56409 16.3404 9.39487C16.3404 13.2256 13.2239 16.3426 9.39291 16.3426C5.56191 16.3426 2.44541 13.2259 2.44541 9.39487C2.44541 5.56387 5.56191 2.44736 9.39291 2.44736Z"
                                                fill="white" />
                                            <path
                                                d="M9.39333 15.6638C12.8499 15.6638 15.6617 12.8518 15.6617 9.39551C15.6617 5.93919 12.8499 3.12695 9.39333 3.12695C5.93678 3.12695 3.125 5.93874 3.125 9.39528C3.125 12.8518 5.93678 15.6638 9.39333 15.6638ZM4.51731 7.26471C4.62303 7.17846 4.76996 7.16352 4.8904 7.22691L7.12806 8.40301L9.116 5.58466C9.24323 5.40423 9.54388 5.40423 9.67089 5.58466L11.6586 8.40301L13.8963 7.22691C14.0172 7.16329 14.1643 7.17846 14.2694 7.26471C14.3749 7.35119 14.4185 7.49224 14.3801 7.62309L12.8433 12.8616C12.8008 13.0062 12.6683 13.1056 12.5175 13.1056H6.26913C6.11835 13.1056 5.98568 13.0062 5.94335 12.8616L4.4066 7.62309C4.36812 7.49224 4.41181 7.35119 4.51731 7.26471Z"
                                                fill="#F1594B" />
                                            <path
                                                d="M12.2644 12.4277L13.5041 8.20237L11.7122 9.14416C11.5612 9.2234 11.3746 9.17858 11.2766 9.03935L9.39439 6.37109L7.5124 9.03935C7.41437 9.1788 7.22805 9.22385 7.07705 9.14416L5.28516 8.20237L6.52465 12.4277H12.2644Z"
                                                fill="white" />
                                            <path
                                                d="M1.39984 10.9866L0.710926 12.7377C0.644141 12.9079 0.723831 13.1006 0.891587 13.1735L2.61714 13.9238L2.65246 15.8051C2.65586 15.9878 2.80301 16.1349 2.98571 16.1383L4.86702 16.1736L5.61751 17.8994C5.69041 18.0672 5.88262 18.1469 6.05332 18.0801L7.80445 17.3912L9.16009 18.6961C9.2914 18.8227 9.49968 18.8227 9.63098 18.6961L10.9864 17.3912L12.7378 18.0801C12.9069 18.1466 13.1004 18.0674 13.1736 17.8994L13.9236 16.1739L15.8051 16.1386C15.9878 16.1352 16.1348 15.988 16.1384 15.8055L16.1735 13.924L17.8993 13.1735C18.0668 13.1006 18.1467 12.9079 18.0797 12.7377L17.3908 10.9866L18.6959 9.63115C18.8225 9.49962 18.8225 9.29157 18.6959 9.16003L17.3908 7.80463L18.0797 6.05349C18.1467 5.88324 18.0668 5.69058 17.8993 5.61768L16.1735 4.86742L16.1384 2.98588C16.1348 2.80341 15.9878 2.65603 15.8051 2.65286L13.9238 2.61754L13.1736 0.891757C13.1004 0.723774 12.9071 0.644311 12.7378 0.711096L10.9864 1.40001L9.63076 0.0950845C9.49945 -0.0316948 9.29117 -0.0316948 9.15986 0.0950845L7.80423 1.40001L6.05309 0.711096C5.88262 0.644311 5.69018 0.724227 5.61729 0.891757L4.86702 2.61731L2.98571 2.65263C2.80301 2.65603 2.65586 2.80318 2.65246 2.98588L2.61714 4.86719L0.891361 5.61768C0.723604 5.69058 0.643914 5.88324 0.7107 6.05349L1.39961 7.80463L0.0949147 9.16003C-0.0316382 9.29157 -0.0316382 9.49962 0.0949147 9.63093L1.39984 10.9866ZM2.0403 8.1184C2.13244 8.02287 2.16029 7.88228 2.11161 7.75867L1.463 6.10986L3.08826 5.40306C3.21029 5.35009 3.28998 5.23078 3.29224 5.09789L3.3253 3.32547L5.09772 3.29241C5.23061 3.28992 5.34992 3.21023 5.40289 3.08844L6.10969 1.4634L7.7585 2.11201C7.88256 2.16068 8.0227 2.13261 8.11823 2.04069L9.39531 0.811161L10.6724 2.04047C10.7679 2.13261 10.9092 2.16046 11.0321 2.11178L12.6814 1.46317L13.388 3.08844C13.4409 3.21046 13.5602 3.29015 13.6931 3.29241L15.4653 3.32547L15.4984 5.09789C15.5011 5.23055 15.5806 5.34986 15.7024 5.40284L17.3276 6.10963L16.679 7.75844C16.6303 7.88205 16.6582 8.02264 16.7501 8.1184L17.9796 9.39548L16.7501 10.6726C16.6582 10.7683 16.6303 10.9089 16.679 11.0325L17.3276 12.6813L15.7024 13.3881C15.5806 13.4411 15.5009 13.5604 15.4984 13.6931L15.4653 15.4655L13.6929 15.4985C13.56 15.501 13.4409 15.5807 13.3877 15.7025L12.6814 17.3276L11.0321 16.679C10.9087 16.6303 10.7679 16.6581 10.6724 16.7503L9.39531 17.9798L8.11823 16.7505C8.02202 16.6579 7.8812 16.631 7.7585 16.6792L6.10969 17.3278L5.40289 15.7025C5.34992 15.5805 5.23061 15.5008 5.09772 15.4985L3.3253 15.4655L3.29224 13.6931C3.28975 13.5602 3.21006 13.4409 3.08826 13.3879L1.46323 12.6811L2.11184 11.0323C2.16029 10.9087 2.13244 10.7681 2.04052 10.6726L0.810991 9.39548L2.0403 8.1184Z"
                                                fill="white" />
                                            <path
                                                d="M9.39282 16.3425C13.2238 16.3425 16.3403 13.2258 16.3403 9.395C16.3403 5.56423 13.2238 2.44727 9.39282 2.44727C5.56182 2.44727 2.44531 5.56377 2.44531 9.39477C2.44531 13.2258 5.56182 16.3425 9.39282 16.3425ZM9.39282 3.12644C12.8494 3.12644 15.6611 5.93845 15.6611 9.39477C15.6611 12.8511 12.8494 15.6633 9.39282 15.6633C5.93627 15.6633 3.12449 12.8513 3.12449 9.39477C3.12449 5.93822 5.93627 3.12644 9.39282 3.12644Z"
                                                fill="#F1594B" />
                                            <path
                                                d="M6.27085 13.1055H12.5193C12.67 13.1055 12.8027 13.0061 12.845 12.8615L14.3818 7.62297C14.4203 7.49212 14.3766 7.35108 14.2711 7.2646C14.1658 7.17834 14.0189 7.16317 13.898 7.22679L11.6603 8.40289L9.67261 5.58454C9.54538 5.40411 9.24473 5.40411 9.11772 5.58454L7.12978 8.40289L4.89212 7.22679C4.77168 7.1634 4.62475 7.17834 4.51903 7.2646C4.41353 7.35108 4.36984 7.49212 4.40832 7.62297L5.94507 12.8615C5.98741 13.0061 6.12007 13.1055 6.27085 13.1055ZM7.07748 9.14274C7.22848 9.22243 7.4148 9.17738 7.51283 9.03792L9.39505 6.36967L11.277 9.03792C11.3751 9.17715 11.5616 9.22198 11.7126 9.14274L13.5045 8.20095L12.2648 12.4263H6.52509L5.28559 8.20095L7.07748 9.14274Z"
                                                fill="white" />
                                        </svg>
                                        <span>BEST VALUE</span>
                                    </div>
                                </div>
                            </div>

                            <input type="radio" :name="'test8-step6' + uniqueId" class="hidden"
                                :id="'test8-item' + index + uniqueId" :checked="state.active.packs == index"
                                @click="setPack(index)" :value="index" />

                            <div>
                                <div v-if="index != 0 || !ThreeColums" class="mt-2 mb-2 text-3xl font-ww-bold">
                                    {{ item.Offer }}
                                </div>

                                <div class="flex flex-shrink-0 justify-center w-full">
                                    <nuxt-img :src="item.Image.url" class="object-contain mx-auto md:mx-left max-h-48"
                                        loading="lazy" format="webp" :width="index == 0 && ThreeColums ? '274' : '332'"
                                        height="224" sizes="sm:284px md:300px lg:300px xl:284px" alt="product" />
                                </div>

                                <div :class="index == 0 && ThreeColums ? 'lg:text-base text-lg' : 'text-lg'"
                                    class="font-ww-regular">
                                    {{ item.SaleRibbon }}
                                </div>
                            </div>

                            <div class="mt-6" v-html="item.Text">
                            </div>





                            <div class="hidden">
                                <svg width="41" height="41" viewBox="0 0 41 41" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="20.5" cy="20.5" r="20" stroke="black" />
                                    <path d="M12.5898 12.2266H32.2051V29.709H25.578" stroke="black"
                                        stroke-width="0.856563" />
                                    <path d="M16.3782 29.7101H9.81641V23.9883" stroke="black" stroke-width="0.856563" />
                                    <path d="M9 21.3078L12.0423 24.1688L17.1277 19.2641L9 11" stroke="black"
                                        stroke-width="0.856563" />
                                    <path
                                        d="M16.3746 20.0449C16.3746 20.0449 17.7802 22.0707 19.6406 21.8437C21.5011 21.6167 21.5253 21.5747 22.0393 21.8437C22.5532 22.1126 25.5513 23.4763 25.5513 23.4763C25.5513 23.4763 24.6825 25.0678 23.2563 24.4888C22.669 24.2721 22.0967 24.0166 21.5432 23.7239C21.5432 23.7239 20.3653 23.8686 21.1919 24.7783C22.0185 25.688 25.5538 29.4491 25.5538 29.4491C25.5538 29.4491 25.9665 30.8753 24.6851 30.9575C23.4036 31.0398 17.9053 30.9575 17.9053 30.9575C17.9053 30.9575 17.4096 31.0192 16.792 30.1721L14.1048 26.8443C13.8046 26.3268 13.7087 25.7158 13.8358 25.1312C14.0011 23.9945 12.6367 23.7256 12.6367 23.7256"
                                        stroke="black" stroke-width="0.856563" />
                                    <path d="M22.5625 29.5527L23.8243 30.9994" stroke="black" stroke-width="0.856563" />
                                    <path d="M20.582 29.5527L21.8439 30.9994" stroke="black" stroke-width="0.856563" />
                                    <path d="M18.3594 29.5527L19.6212 30.9994" stroke="black" stroke-width="0.856563" />
                                    <path d="M18.7188 12.2266V14.6249H23.969V12.2266" stroke="black"
                                        stroke-width="0.856563" />
                                </svg>

                                <div class="text-base font-ww-bold xl:text-lg">
                                    FREE SHIPPING
                                </div>

                            </div>

                        </div>

                    </div>
                </div>

            </div>
            <div v-if="state.isSubscription && hasSellingPlans">
                <div class="text-lg text-red-400 border-red-400">
                    <p class="m-auto mt-4 mb-4 text-lg font-medium leading-tight text-gray-900 sm-max:text-xl">
                        {{ state.items[state.active.items].Name }} by Lifeboost is an ongoing subscription service that
                        is automatically charged each season <span class="font-bold">({{
                            state.items[state.active.items].Variants[state.active.variants].Pack[state.active.packs].Price
                        }}
                            USD)</span> to the payment method
                        provided until you cancel. Taxes, & shipping fees. You may cancel your subscription online at
                        any time
                        before
                        your next bill date, or by contacting Lifeboost Coffee Support at 1-800-479-1596, or by
                        contacting us
                        <a class="underline text-link" target="_blank"
                            href="https://lifeboostcoffee.com/pages/contact-us">here.</a>️
                    </p>
                </div>
                <div class="flex flex-row justify-center my-10 space-x-6">
                    <div class="flex items-start">
                        <div class="flex items-center h-6">
                            <input id="remember" aria-describedby="remember" type="checkbox"
                                :class="['relative w-6 h-6 border drop-shadow-lg rounded cursor-pointer !p-3 !mt-4 bottom-1 bg-gray-50 focus:ring-3 focus:ring-primary-300', { 'highlight-checkbox': highlightCheckbox }]"
                                v-model="checkboxChecked" @change="highlightCheckbox = false" required>
                        </div>
                    </div>
                    <div class="max-w-md text-left text-xs !ml-4">
                        <label for="remember"
                            class="text-lg font-bold text-gray-700 cursor-pointer text-body font-gotham">
                            By clicking "Join our club now", you are agreeing to our Terms of Use and Sale and
                            <a class="text-link" href="https://lifeboostcoffee.com/pages/terms" target="_blank">
                                Lifeboost Coffee Terms
                            </a>
                            and Conditions
                        </label>
                    </div>
                </div>
            </div>
            <div class="md:mx-0 mx-2">
                <button type="button" data-event-name="experiment_event" data-event-action="CTA Click | Add To Cart"
                    data-testid="cta-button" data-event-label="cta_add_to_cart" data-cart-add=""
                    class="bg-orangebtn text-white items-center flex lg:leading-[76px] font-bold justify-center gap-x-2 font-ww-medium lg:text-42 md:mx-0  text-4xl md:px-3 md:py-3.5 py-8 text-center w-full rounded uppercase btn-cta-custom"
                    @click="handleButtonClick($event)" :disabled="!stockCheck()"
                    :class="(!stockCheck() && 'grayscale-1') || (highlightCheckbox && 'highlight-checkbox') || (devMode && 'split-test-outline')"
                    style="box-shadow: 0 -4px 0 #c7642d inset">
                    {{ !stockCheck() ? "OUT OF STOCK" : state.isSubscription ? "JOIN OUR CLUB NOW" : "ADD TO CART" }}

                    <svg width="30" class="md-max:w-4" height="30" viewBox="0 0 30 30" fill="none"
                        xmlns="http://www.w3.org/2000/svg" data-v-inspector="components/ButtonHealthyIcon.vue:6:6">
                        <path
                            d="M3.06727e-06 17.0991L22.7338 17.0991L14.1237 27.288L17.3229 30L30 15L17.3229 -5.54136e-07L14.1237 2.71201L22.7338 12.9009L3.25078e-06 12.9009L3.06727e-06 17.0991Z"
                            fill="white" data-v-inspector="components/ButtonHealthyIcon.vue:7:1"></path>
                    </svg>
                </button>
            </div>

            <div class="flex gap-x-8 justify-center items-center mt-6 mb-6 md:gap-x-10">
                <nuxt-img src="/assets/images/narton-logo.png" class="sm-max:w-20" width="112" height="77" alt="Bogo 1"
                    loading="lazy" format="webp" />
                <nuxt-img src="/assets/images/dss-logo.png" class="sm-max:w-20" width="139" height="53" alt="Bogo 2"
                    loading="lazy" format="webp" />
                <nuxt-img src="/assets/images/256-bit-logo.png" class="sm-max:w-20" width="107" height="51" alt="Bogo 3"
                    loading="lazy" format="webp" />
            </div>

        </div>
        <div class="flex items-center justify-center customPopup2 fixed w-full h-full z-[21474830004] left-0 top-0"
            v-show="state.upgrade.show" :class="state.upgrade.show ? 'active' : ''" id="tail">
            <UpsellRewardsBogo v-if="isBogoEnabled" :state="state" :modal="modal" :runEngine="runEngine"
                :bonusItemsConfig="bonusItemsConfig" :upsell-config="bogoUpsellConfig"
                :upgrade-pack-map="upgradePackMap" />
            <UpsellRegular v-else :state="state" :modal="modal" :runEngine="runEngine"
                :bonusItemsConfig="bonusItemsConfig" />
        </div>
    </div>
</template>

<script setup>
/** 
 * @name SwatchesTest8.5
 * @description Used for Test 8.5 in Builder.io
 */

const props = defineProps({
    UrlLink: {
        type: String,
        default: 'swatches-test-upsell'
    },
    ThreeColums: {
        type: Boolean,
        default: true
    },
})
const uniqueId = ref(generateUniqueId());
const htmlTest = (html) => {
    const regex = /<[^>]+>/; // example: checks if string contains HTML tags
    return regex.test(String(html));
};

const runEngine = new Engine();
const route = useRoute();
const page = ref({ Products: { data: {} }, AOVBooster: [], PreselPack: null });
page.value = await runEngine.queryPage(
    props.UrlLink
);

const products = computed(() => {
    return Object.keys(page.value.Products).reduce(
        (r, v) => ({ ...r, [v]: page.value.Products[v] }),
        {}
    );
});

if (import.meta.client) {
    window.sale_page_data = page.value;
}
// Call loadReviews on component moun

const aovUpgrades = computed(() =>
    page.value.AOVBooster.length ? page.value.AOVBooster[0] : []
);
const Preselected = computed(() =>
    page.value.PreselPack !== null ? page.value.PreselPack - 1 : 0
);
const bogoUpsellConfig = computed(() => page.value?.ExtraData?.upsellTiers || {});
const isBogoEnabled = computed(() => Object.keys(bogoUpsellConfig.value).length > 0);

// Bonus Items Configuration - reads from API (page.value.ExtraData)
// Each bonus item can have: variantId, quantity, price (for _ctf_prc), title (for _ctf_ttl), requiredProduct (variantId that must be in cart)
const bonusItemsConfig = computed(() => {
    const extraData = page.value?.ExtraData;
    if (!extraData?.enabledBonus) return null;

    return {
        enabled: extraData.enabledBonus,
        '3x': extraData['3x'] || [],
        '6x': extraData['6x'] || [],
        getItemsForPack: (packQty) => {
            if (packQty >= 6) return extraData['6x'] || [];
            if (packQty >= 3) return extraData['3x'] || [];
            return [];
        }
    };
});

const highlightCheckbox = ref(false);
const checkboxChecked = ref(false);

const state = reactive({
    layout: ref(""),
    layoutPopup: ref(""),
    subscriptionPage: ref(false),
    pageSteps: ref({}),
    items: products,
    upgrades: aovUpgrades,
    variants: products.value[0].Variants,
    packs: products.value[0].Variants[0].Pack.filter((obj) => obj.Active),
    images: products.value[0].Variants[0].variant.Gallery[0],
    unit: ref({
        beans: ["bag", "bags"],
        pods: ["box", "boxes"],
        ground: ["bag", "bags"],
        wholebeans: ["bag", "bags"],
        coffeeground: ["bag", "bags"],
        coffeebeans: ["bag", "bags"],
        coffeepods: ["box", "boxes"],
    }),
    currentUnit: ref(["bag", "bags"]),
    active: {
        items: 0,
        variants: 0,
        packs: Preselected.value,
        sellingPlan: 0,
    },
    upgrade: ref({
        UpSell: {},
        CrossSell: {},
        show: false,
    }),
    isSubscription: page.value.Subscription ?? false,
    regular: ref({}),
    trackingStack: ref({}),
});


const FilteredPacks = computed(() => {
    return state.items[state.active.items].Variants[
        state.active.variants
    ].Pack.filter((obj) => obj.Active);
});

// Modal object
const modal = reactive({
    show: true,
    page: true,
    product: {
        qty: 0,
        packName: "",
        Coupon: [],
        variantID: 40029155524668
    },
    upsell: {
        show: true,
        activate: false,
    },
    crosssell: {
        show: false,
        variantId: 32453656150076,
        activate: false,
    }
});

// const setProduct = (index) => {
//   const newPacks = products.value[index].Variants[0].Pack.filter((obj) => obj.Active);
// state.packs.splice(0, state.packs.length, ...newPacks);
//     }
// console.log(modal.upsell.show);
// Methods
const setProductModal = (input) => {
    modal.product = {
        qty: input.qty,
        packName: input.packName,
        Coupon: Array.isArray(input.Coupon) ? input.Coupon : [input.Coupon ?? null, null],
        variantID: input.variantID,
    };
    modal.crosssell.variantId = input.crossSellID;
};

const trackEvent = inject("trackEvent");

const setProduct = (index) => {
    index = parseInt(index);
    state.active.items = parseInt(index);
    state.variants = products.value[index].Variants;

    // Preserve variant selection if valid, otherwise reset to 0
    if (state.active.variants >= state.variants.length) {
        state.active.variants = 0;
    }

    state.packs = products.value[index].Variants[state.active.variants].Pack.filter(
        (obj) => obj.Active
    );
    state.images =
        products.value[index].Variants[state.active.variants].variant.Gallery[0];

    // Preserve pack selection if valid, otherwise reset to default
    if (state.active.packs >= state.packs.length) {
        state.active.packs = parseInt(Preselected.value);
    }
};
const setType = (index) => {
    state.active.variants = parseInt(index);

    state.images =
        state.items[state.active.items].Variants[
            state.active.variants
        ].variant.Gallery[0];

    state.packs = state.items[state.active.items].Variants[
        state.active.variants
    ].Pack.filter((obj) => obj.Active);

    // Preserve pack selection if valid, otherwise reset to default
    if (state.active.packs >= state.packs.length) {
        state.active.packs = parseInt(Preselected.value);
    }
};

const setPack = (index) => {
    state.active.packs = parseInt(index);
};

const moveVariantRadio = (dir) => {
    const total = state.variants.length;
    if (total === 0) return;
    state.active.variants = (state.active.variants + dir + total) % total;
    // Move DOM focus to the newly active radio element
    nextTick(() => {
        const radios = document.querySelectorAll('[role="radio"][aria-label="Ground or Beans?"], [role="radiogroup"][aria-label="Ground or Beans?"] [role="radio"]');
        if (radios[state.active.variants]) {
            radios[state.active.variants].focus();
        }
    });
};

const movePackRadio = (dir) => {
    const total = FilteredPacks.value.length;
    if (total === 0) return;
    state.active.packs = (state.active.packs + dir + total) % total;
    // Move DOM focus to the newly active radio element
    nextTick(() => {
        const radios = document.querySelectorAll('[role="radiogroup"][aria-label="How many bags?"] [role="radio"]');
        if (radios[state.active.packs]) {
            radios[state.active.packs].focus();
        }
    });
};

const setPrice = (item) => {
    const amount = item.PackSize.replace("x", "");
    const sale =
        state.variants[state.active.variants].variant.VariantPrice;
    return "$" + (amount * sale).toFixed(2);
};



const stockCheck = () => {
    return state.items[state.active.items].Variants[state.active.variants].variant
        .inStock;
};

const hasSellingPlans = () => {

    return state.items[state.active.items].Variants[state.active.variants].variant.SellingPlans.length > 0;
}


const devMode = useCookie('devMode')

// Lifecycle hook onMounted (equivalent to init in Alpine.js)
onMounted(() => {
    runEngine.fetchProduct(["6938980876348", "6980372004924", "7148455624764", "8023271014460"]).then(() => {
        Object.keys(state.items).map((key) => {
            return state.items[key].Variants.map((variant, index) => {
                state.items[key].Variants[index].variant.inStock =
                    runEngine.getInStock(variant.variant.VariantID);
                state.items[key].Variants[index].variant.SellingPlans =
                    runEngine.getVariant(variant.variant.VariantID).sellingPlanAllocations.nodes;
            });
        });
    });

});

const getPackQuantity = (pack) => Number.parseInt(pack?.PackSize?.replace("x", ""), 10);
const upgradePackMap = {
    x1: "x3",
    x3: "x6",
    x6: "x12",
};

const getCurrentSelection = () => {
    const item = state.items[state.active.items];
    const variant = item?.Variants[state.active.variants];
    const pack = FilteredPacks.value[state.active.packs];

    return {
        item,
        variant,
        pack,
        variantID: variant?.variant?.VariantID,
    };
};

const buildModalCoupons = (upgradeCoupon, packCoupon) => [
    upgradeCoupon ?? null,
    packCoupon ?? null,
];

const shouldUseTripleCopy = (currentPack, upgradePack) =>
    currentPack?.PackSize === "x1" && upgradePack?.PackSize === "x3";

const formatUpgradeCopy = (text, currentPack, upgradePack) => {
    return text
    //stopped for now
    if (typeof text !== "string" || !shouldUseTripleCopy(currentPack, upgradePack)) {
        return text;
    }

    return text
        .replace(/DOUBLE/g, "TRIPLE")
        .replace(/Double/g, "Triple")
        .replace(/double/g, "triple");
};

const getUpgradePack = (variant, pack) => {
    const targetPackSize = upgradePackMap[pack?.PackSize];

    if (!targetPackSize) {
        return null;
    }

    return variant?.Pack?.find((obj) => obj.PackSize === targetPackSize) ?? null;
};

const getCrossSellOfferData = (variant, pack) => {
    const variantSku = state.upgrades?.CrossSellOffer?.VariantId?.VariantSKU;
    const offer = getUpgradePack(variant, pack);

    if (!variantSku || !offer) {
        return null;
    }

    try {
        const parsedVariantSku = JSON.parse(variantSku);
        const crossSellID =
            parsedVariantSku[
            variant.Name.toLowerCase().includes("bean") ? "beans" : "ground"
            ];

        if (!crossSellID) {
            return null;
        }

        return { offer, crossSellID };
    } catch (error) {
        console.warn("Invalid cross-sell VariantSKU config", error);
        return null;
    }
};

const getUpsellPackOfferData = (variant, pack) => {
    const upsellPackOffer = Array.isArray(state.upgrades?.UpsellPackOffer)
        ? state.upgrades.UpsellPackOffer.find(
            (obj) => obj.PackSizeRun === pack?.PackSize
        )
        : null;

    if (!upsellPackOffer) {
        return null;
    }

    const offer = variant?.Pack?.find(
        (obj) => obj.PackSize === upsellPackOffer.PackUpgrade
    );

    if (!offer) {
        return null;
    }

    return { upsellPackOffer, offer };
};

const hasAvailableUpgrade = () => {
    const { variant, pack } = getCurrentSelection();

    if (!variant || !pack) {
        return false;
    }

    return Boolean(
        getCrossSellOfferData(variant, pack) ||
        getUpsellPackOfferData(variant, pack)
    );
};

const buildBonusCheckoutItems = (packQty, mainVariantId) => {
    const config = bonusItemsConfig.value;

    if (!config?.enabled) {
        return [];
    }

    return config.getItemsForPack(packQty).map((bonusItem) => {
        const attributes = [
            {
                key: "_ctf_prc",
                value: String(bonusItem.price ?? 0),
            },
        ];

        if (bonusItem.title) {
            attributes.push({
                key: "_ctf_ttl",
                value: bonusItem.title,
            });
        }

        if (bonusItem.requiredProduct) {
            const parentVariantId =
                typeof bonusItem.requiredProduct === "string"
                    ? bonusItem.requiredProduct
                    : String(mainVariantId);

            attributes.push({
                key: "_ctf_req_prd",
                value: JSON.stringify({ i: parentVariantId, q: 1 }),
            });
        }

        return {
            id: bonusItem.variantId,
            quantity: bonusItem.quantity,
            attributes,
        };
    });
};

const addToCart = () => {
    const { item, variant, pack, variantID } = getCurrentSelection();

    if (!item || !variant || !pack || !variantID) {
        return;
    }

    const image = pack.Image?.url;

    state.regular = {
        product: item.Name,
        variant: variant.Name,
        pack: pack.Name,
        quantity: pack.PackSize.replace("x", ""),
        Coupon: pack.Coupon,
        varID: variantID,
    };


    const crossSellData = getCrossSellOfferData(variant, pack);
    const upsellPackData = getUpsellPackOfferData(variant, pack);

    if (crossSellData) {
        document.body.style.overflow = "hidden";
        const oferTa = crossSellData.offer;
        const CrossSellVariant = crossSellData.crossSellID;
        setProductModal({
            qty: pack.PackSize.replace("x", ""),
            packName: pack.Name,
            Coupon: buildModalCoupons(oferTa.Coupon, pack.Coupon),
            variantID: variantID,
            crossSellID: CrossSellVariant,
        });
        state.upgrade = {
            product: item.Name,
            pack: oferTa.PackName ?? oferTa.Name ?? pack.Name,
            variant: variant.Name,
            varID: variantID,
            quantity: getPackQuantity(oferTa),
            PackDiff: getPackQuantity(oferTa) - getPackQuantity(pack),
            UpSell: {
                PreHeader: formatUpgradeCopy(state.upgrades.UpsellOffer?.PreHeader, pack, oferTa),
                Header: formatUpgradeCopy(state.upgrades.UpsellOffer?.Header, pack, oferTa),
                SubHeader: formatUpgradeCopy(state.upgrades.UpsellOffer?.SubHeader, pack, oferTa),
                Image: state.upgrades.UpsellOffer?.Image?.url || image,
                ButtonText: "Yes! Upgrade My Order",
            },
            CrossSell: {
                Body: state.upgrades.CrossSellOffer?.Body,
                Header: state.upgrades.CrossSellOffer?.Header,
                Image: state.upgrades.CrossSellOffer?.Image?.url || image,
                PricenSave: state.upgrades.CrossSellOffer?.PricenSave,
                ButtonText: "Yes! Upgrade My Order",
            },
            // Image: pack.Image.url,
            OfferType: oferTa.OfferType,
            Discount: oferTa.Discount,
            Coupon: oferTa.Coupon,
            Price: oferTa.Price,
            show: true,
        };
    } else if (upsellPackData) {
        document.body.style.overflow = "hidden";
        const oferTi = upsellPackData.upsellPackOffer;
        const oferTa = upsellPackData.offer;
        if (state.layoutPopup == "L02") {
            setProductModal({
                qty: pack.PackSize.replace("x", ""),
                packName: pack.Name,
                Coupon: buildModalCoupons(oferTa.Coupon, pack.Coupon),
                variantID: variantID,
            });
        }
        state.upgrade = {
            product: item.Name,
            pack: pack.Name,
            variant: variant.Name,
            varID: variantID,
            quantity: oferTi.PackUpgrade.replace("x", ""),
            PackDiff:
                oferTi.PackUpgrade.replace("x", "") -
                oferTi.PackSizeRun.replace("x", ""),
            PreHeader: oferTi.PreHeader,
            Header: oferTi.Header,
            SubHeader: oferTi.SubHeader,
            Image: oferTi.Image?.url || image,
            // Image: pack.Image.url,
            OfferType: oferTa.OfferType,
            Discount: oferTa.Discount,
            Coupon: oferTa.Coupon,
            Price: oferTa.Price,
            ButtonText: oferTi.ButtonText,
            show: true,
        };

    } else {
        addToCartNoUpsell();
    }
};
const addToCartNoUpsell = () => {
    const { item, variant, pack, variantID } = getCurrentSelection();

    if (!item || !variant || !pack || !variantID) {
        return;
    }

    const packQty = getPackQuantity(pack);
    const checkoutItems = [
        ...buildBonusCheckoutItems(packQty, variantID),
        {
            id: variantID,
            quantity: pack.PackSize.replace("x", ""),
            packName: pack.PackName || pack.Name,
            coupon: pack.Coupon,
        },
    ];
    const cartTransformData = {
        [variantID]: {
            price: pack.UnitPrice,
            storefrontTitle: pack.StorefrontTitle || "",
        },
    };

    runEngine.checkoutWithItems(checkoutItems, trackEvent, cartTransformData);
};

const handleButtonClick = (event) => {
    if (hasAvailableUpgrade()) {
        addToCart();
    } else {
        addToCartNoUpsell();
    }

    // track upsell offer view
    if (import.meta.client && Array.isArray(window.dataLayer)) {
        trackOffer.view({
            id: 1,
            name: 'Upsell and Cross-sell' // Double Order or Signature Bundle
        });
    }
    builderTrackEvent("add_to_cart_button_click");
};



defineBuilderComponent({
    friendlyName: "SwatchesBogoNew",
    canHaveChildren: true,
    inputs: [
        {
            name: "UrlLink",
            type: "string",
            defaultValue: "swetches"
        },
        {
            name: "ThreeColums",
            type: "boolean",
            defaultValue: true
        }
    ]
});

function generateUniqueId() {
    return Math.random().toString(36).substring(2, 15);
}
</script>

<style scoped>
.highlight-checkbox {
    box-shadow: 0 0 5px red;
}

label * {
    cursor: pointer;
    pointer-events: none;
}

input:checked~.show {
    display: block;
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 150ms;
}

input:checked~.showbg {
    --tw-border-opacity: 1;
    border-color: rgba(255, 255, 255, var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

input:checked~.showbg.gray {
    --tw-bg-opacity: 1;
    background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

input:checked~.showbg.green {
    --tw-border-opacity: 1;
    border-color: rgba(156, 163, 175, var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(123, 189, 65, var(--tw-bg-opacity));
}

input:checked~.showbg.yellow {
    --tw-bg-opacity: 1;
    background-color: rgba(250, 204, 21, var(--tw-bg-opacity));
}

input:checked~.showbg.cath {
    --tw-bg-opacity: 1;
    background-color: rgba(113, 63, 18, var(--tw-bg-opacity));
}

input:checked~.showcolor-white {
    --tw-text-opacity: 1;
    color: rgba(255, 255, 255, var(--tw-text-opacity));
}

input:checked~.text-o {
    --tw-text-opacity: 1;
    color: rgba(202, 138, 4, var(--tw-text-opacity));
}

input:checked~.off {
    display: none;
}

.swatch {
    position: relative;
    cursor: pointer;
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(156, 163, 175, var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
    padding-top: 0.625rem;
    padding-bottom: 0.625rem;
    padding-left: 0.875rem;
    padding-right: 0.875rem;
    font-weight: 500;
}

@media (min-width: 1024px) {
    .swatch {
        padding: 0.875rem;
    }
}

.swatch--tshirt {
    width: auto;
    width: initial;
    margin-bottom: 10px;
}

.swatch--active {
    --tw-bg-opacity: 1;
    background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

.swatch--active svg {
    display: block !important;
}

.swatch--disabled {
    opacity: 0.15;
    text-decoration: line-through;
}

input:checked~.swatch--packs {
    --tw-border-opacity: 1;
    border-color: rgba(255, 255, 255, var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

input:checked~.swatch--packs.gray {
    --tw-bg-opacity: 1;
    background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

input:checked~.showbg.swatch--packs {
    --tw-bg-opacity: 1;
    background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

input:checked~.swatch--packs.green {
    --tw-border-opacity: 1;
    border-color: rgba(156, 163, 175, var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(123, 189, 65, var(--tw-bg-opacity));
}

input:checked~.swatch--packs.yellow {
    --tw-bg-opacity: 1;
    background-color: rgba(250, 204, 21, var(--tw-bg-opacity));
}

input:checked~.swatch--packs.cath {
    --tw-bg-opacity: 1;
    background-color: rgba(113, 63, 18, var(--tw-bg-opacity));
}

.swatch--packs {
    position: absolute;
    position: relative;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    z-index: 0;
    min-width: -moz-min-content;
    min-width: min-content;
    cursor: pointer;
    border-radius: 0.5rem;
    border-width: 1px;
    --tw-border-opacity: 1;
    border-color: rgba(156, 163, 175, var(--tw-border-opacity));
    --tw-bg-opacity: 1;
    background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
    font-weight: 500;
}

.swatch--packs.swatch--active {
    --tw-bg-opacity: 1;
    background-color: rgba(229, 231, 235, var(--tw-bg-opacity));
}

.swatch--packs {
    padding: 15px 0 0 0;
    width: inherit;
}

.swatch {
    width: inherit;
}

.swatch--packs:nth-child(1) {
    padding: 15px 0 !important;
}

input:checked~.off {
    display: none;
}

input:checked~.off[data-sizes="auto"] {
    display: none;
}

.lazy__container input:checked~.off {
    display: none;
}

input:checked~.text-o {
    --tw-text-opacity: 1;
    color: rgba(202, 138, 4, var(--tw-text-opacity));
}

.progress {
    background-color: #f5f5f5;
    border-radius: 3px;
    box-shadow: none;
}

.progress-bar {
    background-color: #2196f3;
    box-shadow: none;
}

@-webkit-keyframes progress-bar-stripes {
    from {
        background-position: 40px 0;
    }

    to {
        background-position: 0 0;
    }
}

@keyframes progress-bar-stripes {
    from {
        background-position: 40px 0;
    }

    to {
        background-position: 0 0;
    }
}

.progress-bar.active,
.progress.active .progress-bar {
    -webkit-animation: progress-bar-stripes 2s linear infinite;
    -o-animation: progress-bar-stripes 2s linear infinite;
    animation: progress-bar-stripes 2s linear infinite;
}

.progress-bar-striped,
.progress-striped .progress-bar {
    background-image: -webkit-linear-gradient(45deg,
            rgba(255, 255, 255, 0.15) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.15) 50%,
            rgba(255, 255, 255, 0.15) 75%,
            transparent 75%,
            transparent);
    background-image: -o-linear-gradient(45deg,
            rgba(255, 255, 255, 0.15) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.15) 50%,
            rgba(255, 255, 255, 0.15) 75%,
            transparent 75%,
            transparent);
    background-image: linear-gradient(45deg,
            rgba(255, 255, 255, 0.15) 25%,
            transparent 25%,
            transparent 50%,
            rgba(255, 255, 255, 0.15) 50%,
            rgba(255, 255, 255, 0.15) 75%,
            transparent 75%,
            transparent);
    background-size: 40px 40px;
}

.progress-bar-success {
    background-color: #00a968;
}

button.cart-popup-close:after {
    display: inline-block;
    content: "\00d7";
}

button.cart-popup-close {
    background: none;
    color: inherit;
    border: none;
    font-family: "Gruppo";
    color: #4e4e4e;
    font-size: 30px;
    position: absolute;
    right: 15px;
    top: 10px;
}

.upgrade-save-btn {
    cursor: pointer;
}

.product-image img,
.temp-fix {
    height: 200px;
    object-fit: contain;
}

.fix-height {
    height: 125px;
    object-fit: contain;
}

.fix-one-height {
    height: 240px;
    object-fit: contain;
}

[x-cloak] {
    display: none !important;
}

.grayscale-1 {
    filter: grayscale(1);
    pointer-events: none;
}

.flex-viewport {
    min-height: 550px;
}

@media only screen and (min-width: 500px) {
    .flex-viewport {
        min-height: 650px;
    }
}


@media only screen and (max-width: 580px) {
    .shadow-custom {
        box-shadow: 0 7px 4px 0 rgba(0, 0, 0, 0.25)
    }
}

@media only screen and (max-width: 1024px) {
    .center-flex-mobile>:deep(strong) {
        display: flex;
        justify-content: center;
    }

    :deep(.custom-swatches-price small s) {
        font-size: 15px !important;
    }

    :deep(.custom-swatches-price span) {
        font-size: 17px !important;
    }

    :deep(.custom-swatches-price span s) {
        font-size: 22px !important;
    }

}


:deep(.bogo-benefit-list) {
    margin-bottom: 1.25rem;
    padding-left: 0.5rem;
}

@media (min-width: 1280px) {
    :deep(.bogo-benefit-list) {
        margin-bottom: 1.5rem;
    }
}

:deep(.bogo-benefit-item) {
    display: flex;
    align-items: flex-start;
    width: 100%;
    color: #000000;
    margin-bottom: 0px !important;
    line-height: 24px;
}

:deep(.bogo-benefit-bullet) {
    margin-right: 0.5rem;
    font-weight: 700;
    font-size: 1.125rem;
    line-height: 1.25;
    flex-shrink: 0;
    position: relative;
    top: 0px
}

@media (min-width: 640px) {
    :deep(.bogo-benefit-bullet) {
        font-size: 1.25rem;
    }

    :deep(.custom-last-row .bogo-benefit-value) {
        margin-top: 0px;
        text-align: right !important;
        width: 46% !important;
        white-space: break-spaces;
        line-height: 20px;
    }
}

:deep(.custom-last-row .bogo-benefit-value) {
    margin-top: 4px;
    text-align: left;
    width: fit-content;
    white-space: break-spaces;
    line-height: 20px;
    margin-right: 0px;
}



:deep(.bogo-benefit-content) {
    display: block;
    position: relative;
    overflow: hidden;
    z-index: 1;
    width: 100%;
    padding-right: 140px;
    text-align: left;
}

:deep(.pr-deep-0) {
    padding-right: 0 !important;
}

:deep(.bogo-benefit-label) {
    font-size: 1.125rem;
    line-height: 1.25;
    display: inline;
    background-color: #ffffff;
    padding-right: 0.25rem;
}



:deep(.bogo-benefit-line) {
    position: absolute;
    bottom: 0.35rem;
    /* ~6px */
    left: 0;
    width: 100%;
    border-bottom: 1.5px solid #DEDEDE;
    z-index: -1;
}

:deep(.bogo-benefit-value) {
    float: right;
    white-space: nowrap;
    font-size: 0.875rem;
    padding-left: 0.25rem;
    background-color: #ffffff;
    position: relative;
    z-index: 10;
    margin-top: 4px;
    margin-right: -140px;
}

:deep(.bogo-divider) {
    width: 100%;
    border-top: 1.5px solid #B9B9B9;
    border-bottom: 1.5px solid #B9B9B9;
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
    height: 5px;
}

@media (min-width: 1280px) {
    :deep(.bogo-divider) {
        margin-top: 1.5rem;
        margin-bottom: 1.5rem;
    }

    :deep(.custom-last-row .bogo-benefit-value) {
        margin-top: 0px;
        text-align: right;
        width: 200px !important;
        white-space: break-spaces;
        line-height: 20px;
    }
}

:deep(.bogo-summary-container) {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

@media (max-width: 639px) {
    :deep(.bogo-summary-container) {
        align-items: flex-start;
        row-gap: 1rem;
    }

    :deep(.custom-last-row .bogo-benefit-content) {
        padding-right: 40px;
    }

    :deep(.custom-last-row .bogo-benefit-value) {
        float: left !important;
    }

    :deep(.custom-last-row .bogo-benefit-value) {
        padding-left: 0px !important;
    }
}

:deep(.custom-last-row .bogo-benefit-content) {
    padding-right: 0 !important;
}

:deep(.bogo-shipping-block) {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: flex-start;
}

:deep(.bogo-shipping-block > :not([hidden]) ~ :not([hidden])) {
    margin-left: 0.75rem;
}

@media (min-width: 640px) {
    :deep(.bogo-shipping-block) {
        width: auto;
    }
}

@media (min-width: 1024px) {
    :deep(.bogo-shipping-block > :not([hidden]) ~ :not([hidden])) {
        margin-left: 0.25rem;
    }
}

@media (min-width: 1280px) {
    :deep(.bogo-shipping-block > :not([hidden]) ~ :not([hidden])) {
        margin-left: 0.75rem;
    }
}

:deep(.bogo-shipping-text) {
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    text-align: left;
    color: #000000;
    line-height: 1rem !important;
    font-family: wigrum-regular, wigrum-regular;
}

@media (min-width: 1024px) {
    :deep(.bogo-shipping-text) {
        font-size: 0.75rem;
    }
}

@media (min-width: 1280px) {
    :deep(.bogo-shipping-text) {
        font-size: 0.875rem;
    }
}

:deep(.bogo-price-block) {
    text-align: right;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
}

@media (max-width: 639px) {
    :deep(.bogo-price-block) {
        width: 100%;
        text-align: left;
    }
}

:deep(.bogo-total-value) {
    font-size: 1.125rem;
    color: #000000;
    text-align: right;
    line-height: 1.5rem !important;
}

:deep(.bogo-total-value span) {
    text-decoration: line-through;
}

@media (min-width: 1024px) {
    :deep(.bogo-total-value) {
        font-size: 1rem;
    }
}

@media (min-width: 1280px) {
    :deep(.bogo-total-value) {
        font-size: 1.125rem;
    }
}



.bogo-total-value,
.bogo-today-price {
    text-align: right;
}

:deep(.bogo-today-price) {
    color: #33591F;
    font-weight: 700;
    font-size: 21px;
    text-align: right;
}

@media (min-width: 1024px) {
    :deep(.bogo-today-price) {
        font-size: 1.125rem;
    }
}

@media (min-width: 1280px) {
    :deep(.bogo-today-price) {
        font-size: 21px;
    }
}

.custom-active-bg :deep(.bogo-benefit-label),
.custom-active-bg :deep(.bogo-benefit-value) {
    background-color: #F3F9EE !important;
}

.custom-active-bg :deep(.bogo-today-price) {
    color: #000000;
}
</style>
